import React, { useState } from "react";
import { Platform, Pressable, View } from "react-native";
import { DatePickerModal } from "react-native-paper-dates";
import { Input } from "@components/atoms";
import { useTheme } from "styled-components/native";
import { isValidDate } from "@utils/product/productValidators";
import Tooltip from "@components/atoms/Tooltip";
import moment from "moment";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

let Calendar: any;
if (Platform.OS === "web") {
  Calendar = require("react-calendar").default;
  require("react-calendar/dist/Calendar.css");
}

const dateFormat = "DD MMM, yyyy";
const getDate = (updated_at?: string) => {
  var currentDate = moment(updated_at).format(dateFormat);
  return currentDate;
};

type CrossPlatformCalendarProps = {
  label: string;
  value: string;
  onChange: (date: string) => void;
  required: boolean;
  error: string;
  minDate?: Date;
};
const CrossPlatformCalendar = ({
  label,
  value,
  onChange,
  required,
  error,
  minDate,
}: CrossPlatformCalendarProps) => {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  if (Platform.OS === "web") {
    return (
      <Tooltip
        isOpen={open}
        setIsOpen={() => null}
        onClose={() => {
          setOpen(false);
        }}
        popoverProps={{ size: "md" }}
        useRNModal={true}
        trigger={() => (
          <Pressable onPress={() => setOpen(true)}>
            <Input
              inputLabel={`${label}${required ? "*" : ""}`}
              value={value}
              error={error}
              rightIcon="calendar"
              rightIconColor={theme["core-06"]}
              onRightIconPress={() => setOpen(true)}
            />
          </Pressable>
        )}
        showOnPress
        tooltipBackgroundColor={theme["core-01"]}
        popoverBackdropColor={"transparent"}
      >
        <Calendar
          minDate={minDate ?? new Date()}
          locale={i18next.language}
          onChange={(date: Date) => {
            const formattedDate = `${date.getDate()} ${date.toLocaleString(
              "en-US",
              { month: "short" }
            )}, ${date.getFullYear()}`;
            onChange(formattedDate);
            setOpen(false);
          }}
          value={value && isValidDate(value) ? new Date(value) : undefined}
        />
      </Tooltip>
    );
  }

  return (
    <>
      {(Platform.OS as string) !== "web" && (
        <Pressable onPress={() => setOpen(true)}>
          <View pointerEvents="none">
            <Input
              inputLabel={`${label}${required ? "*" : ""}`}
              value={value}
              error={error}
              rightIcon="calendar"
              rightIconColor={theme["core-06"]}
              onRightIconPress={() => setOpen(true)}
            />
          </View>
        </Pressable>
      )}
      <DatePickerModal
        locale="en-US"
        mode="single"
        saveLabel={t("productDetailPage.datepicker.save.text")}
        label={t("productDetailPage.datepicker.selectdate.text")}
        visible={open}
        onDismiss={() => setOpen(false)}
        date={value && isValidDate(value) ? new Date(value) : undefined}
        onConfirm={(params) => {
          setOpen(false);
          onChange(getDate(params.date?.toString()));
        }}
        validRange={{
          startDate:
            minDate ?? new Date(new Date().setDate(new Date().getDate() - 1)),
        }}
      />
    </>
  );
};

export default CrossPlatformCalendar;
